import React from 'react';
import Layout from '../Layout';
import { Typography, Container, Box, Grid } from '@material-ui/core';
import CropFreeIcon from '@material-ui/icons/CropFree';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import TouchAppIcon from '@material-ui/icons/TouchApp';
import "./Breakdown.css";
import { useNavigate } from 'react-router-dom';
import CustomBreadcrumbs from '../Breadcrumb';


//we r not using this component
const TriggerBreakdown = () => {
    const navigate = useNavigate();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' }
    ];

    const handler = (route) => {
        navigate(route)
    }
    return (
        <Layout>
            <Container>
                <Box mt={1}>
                    <Typography variant="h3" component="h1" gutterBottom>
                        Report Breakdown
                    </Typography>
                </Box>
                <Box mb={3}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Report Breakdown" />
                </Box>
                <Box mb={2}>
                    <Grid container spacing={4}>
                        <Grid item xs={12} sm={5} className='PM'>
                            <div className='breakdown-items'>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <CropFreeIcon />
                                    <p className='text'>
                                        Scan Code
                                    </p>
                                </div>
                                <DoubleArrowIcon />
                            </div>
                        </Grid>
                        <Grid item className='PM' xs={12} sm={5} onClick={() => handler("/report-breakdown/select-asset")}>
                            <div className='breakdown-items'>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <TouchAppIcon />
                                    <p className='text'>
                                        Select Asset
                                    </p>
                                </div>
                                <DoubleArrowIcon />
                            </div>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
        </Layout>
    );
};

export default TriggerBreakdown;
